import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  emApp,
  ehIOS,
  tentarInstalar,
  ICONE_APP,
  estaInstalando,
  aoMudarInstalando,
} from '@/lib/app';
import { mostrarToast } from '@/lib/formularioGuiado';
import Logo from '@/components/ui/Logo';
import FolhaInstalarDoisPassos from '@/components/feature/FolhaInstalarDoisPassos';
import FolhaColocarNaTela from '@/components/feature/FolhaColocarNaTela';

const beneficios = [
  { icone: 'ri-home-5-line', texto: 'Abre direto da tela do seu celular' },
  { icone: 'ri-ticket-2-line', texto: 'Seus ingressos sempre à mão' },
  { icone: 'ri-notification-3-line', texto: 'Avisa quando o pagamento confirma' },
];

export default function InstalarPage() {
  const [folhaAndroid, setFolhaAndroid] = useState(false);
  const [folhaColocar, setFolhaColocar] = useState(false);
  const [fraseDestaque, setFraseDestaque] = useState<string | undefined>(undefined);
  const [instalando, setInstalando] = useState(() => estaInstalando());

  useEffect(() => aoMudarInstalando(setInstalando), []);

  function aoInstalar() {
    const resultado = tentarInstalar();
    if (resultado === 'prompt') return;
    if (resultado === 'android') {
      setFolhaAndroid(true);
      return;
    }
    if (resultado === 'ios' || resultado === 'ios-outro') {
      setFraseDestaque(
        resultado === 'ios-outro'
          ? 'No iPhone, isso é feito pelo Safari: toque em ⋯ › Abrir no Safari, e depois siga os passos.'
          : undefined,
      );
      setFolhaColocar(true);
      return;
    }
    mostrarToast('Use o menu do navegador para instalar o Se Liga.');
  }

  const instalado = emApp();

  return (
    <div className="min-h-screen bg-background-50">
      <header className="sticky top-0 z-40 border-b border-secondary-200/60 bg-white/90 backdrop-blur-md">
        <div className="mx-auto flex h-14 w-full max-w-[1040px] items-center gap-2 px-4 md:px-6">
          <Link
            to="/"
            aria-label="Voltar"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-foreground-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-arrow-left-line text-xl" />
          </Link>
          <Logo />
        </div>
      </header>

      <main className="mx-auto w-full max-w-[1040px] px-4 py-10 text-center md:px-6">
        <img
          src={ICONE_APP}
          alt="Se Liga Católico"
          className="mx-auto h-24 w-24 rounded-[28px] object-cover"
        />
        <h1 className="mt-6 text-2xl font-bold text-foreground-950">
          Instale o Se Liga no seu celular
        </h1>
        <p className="mt-2 text-sm text-foreground-600">
          Um toque e seus ingressos ficam sempre à mão.
        </p>

        <ul className="mx-auto mt-8 max-w-xs space-y-4 text-left">
          {beneficios.map((b) => (
            <li key={b.texto} className="flex items-center gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                <i className={b.icone} />
              </span>
              <span className="text-sm text-foreground-800">{b.texto}</span>
            </li>
          ))}
        </ul>

        {instalado ? (
          <div className="mx-auto mt-10 flex max-w-xs items-center justify-center gap-2 rounded-xl bg-accent-100 px-5 py-3.5 text-sm font-semibold text-accent-900">
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-check-double-line" />
            </span>
            O Se Liga já está na sua tela!
          </div>
        ) : (
          <button
            type="button"
            onClick={aoInstalar}
            disabled={instalando}
            className="mx-auto mt-10 flex h-[52px] w-full max-w-xs cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-primary-500 px-6 text-base font-semibold text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className={instalando ? 'ri-loader-4-line animate-spin' : 'ri-download-2-line'} />
            </span>
            {instalando ? 'Instalando…' : 'Instalar agora'}
          </button>
        )}

        {ehIOS && !instalado && (
          <p className="mx-auto mt-6 max-w-xs text-xs leading-relaxed text-foreground-400">
            No iPhone, o Se Liga entra na tela pelo Safari — tocando em Instalar agora você vê o
            passo a passo.
          </p>
        )}
      </main>

      {folhaAndroid && <FolhaInstalarDoisPassos aoFechar={() => setFolhaAndroid(false)} />}
      {folhaColocar && (
        <FolhaColocarNaTela aoFechar={() => setFolhaColocar(false)} fraseDestaque={fraseDestaque} />
      )}
    </div>
  );
}